import { $ as GetCompactedEventlogResponse, $n as UpdateRequest, $t as ListDeletedRequest, A as DocumentFilter, An as ScheduledDocument, At as GetSchemaResponse, B as EvictRequest, Bn as Status, Bt as GetStatusRulesResponse, C as DeleteRecord, Cn as RegisterMetaTypeUseResponse, Ct as GetMetricsRequest, D as DeleteWorkflowResponse, Dn as RegisterMetricResponse, Dt as GetPermissionsRequest, E as DeleteWorkflowRequest, En as RegisterMetricRequest, Et as GetNilStatusesResponse, F as DocumentVersion, Fn as Schemas, Ft as GetStatusOverviewRequest, G as ExtractedValues, Gn as TypeConfiguration, Gt as GetWithheldRequest, H as Exemplar, Hn as StatusRule, Ht as GetStatusesResponse, I as DocumentWorkflow, In as SetActiveSchemasRequest, It as GetStatusOverviewResponse, J as GetAllActiveSchemasRequest, Jn as UnlockResponse, Jt as GetWorkflowResponse, K as FilterOperator, Kn as TypeTimeExpression, Kt as GetWithheldResponse, L as Documents, Ln as SetActiveSchemasResponse, Lt as GetStatusRequest, M as DocumentMeta, Mn as SchemaActivation, Mt as GetSocketTokenResponse, N as DocumentMetrics, Nn as SchemaGeneration, Nt as GetStatusHistoryReponse, O as DeliverableInfo, On as RestoreRequest, Ot as GetPermissionsResponse, P as DocumentStatuses, Pn as SchemaReference, Pt as GetStatusHistoryRequest, Q as GetCompactedEventlogRequest, Qn as UpdatePermissionsResponse, Qt as ListActiveSchemasResponse, R as EntityRef, Rn as SetWorkflowRequest, Rt as GetStatusResponse, S as DeleteMetricKindResponse, Sn as RegisterMetaTypeUseRequest, St as GetMetricKindsResponse, T as DeleteStatusRuleResponse, Tn as RegisterMetricKindResponse, Tt as GetNilStatusesRequest, U as ExtendLockRequest, Un as StatusUpdate, Ut as GetTypeConfigurationRequest, V as EvictResponse, Vn as StatusOverviewItem, Vt as GetStatusesRequest, W as ExtractedValue, Wn as Timespan, Wt as GetTypeConfigurationResponse, X as GetAttachmentsRequest, Xn as UpdateDeprecationResponse, Xt as LabelExpression, Y as GetAllActiveSchemasResponse, Yn as UpdateDeprecationRequest, Yt as ImportDirective, Z as GetAttachmentsResponse, Zn as UpdatePermissionsRequest, Zt as ListActiveSchemasRequest, _ as CreateUploadRequest, _n as PurgeResponse, _t as GetMetaRequest, a as BulkGetDeliverableInfoRequest, an as LockGrant, ar as ValidationResult, at as GetDocumentResponse, b as DeleteDocumentResponse, bn as RegisterMetaTypeRequest, bt as GetMetaTypesResponse, c as BulkGetReference, cn as MetaDocument, ct as GetEventlogRequest, d as BulkUpdateRequest, dn as MetricAggregation, dt as GetExemplarsResponse, en as ListDeletedResponse, er as UpdateResponse, et as GetDeliverableInfoRequest, f as BulkUpdateResponse, fn as MetricKind, ft as GetHistoryRequest, g as CreateStatusRuleResponse, gn as PurgeRequest, gt as GetMetaDoc, h as CreateStatusRuleRequest, hn as PruneResponse, ht as GetMatchingResponse, i as AttachmentRef, in as LockExclusivity, ir as ValidateResponse, it as GetDocumentRequest, j as DocumentMatch, jn as Schema, jt as GetSocketTokenRequest, k as Deprecation, kn as RestoreResponse, kt as GetSchemaRequest, l as BulkGetRequest, ln as MetaTypeInfo, lt as GetEventlogResponse, m as ConfigureTypeResponse, mn as PruneRequest, mt as GetMatchingRequest, n as AcquireLock, nn as ListSchemaGenerationsResponse, nr as UpdateStatusResponse, nt as GetDeprecationsRequest, o as BulkGetDeliverableInfoResponse, on as LockRequest, or as WorkflowStatus, ot as GetDocumentTypesRequest, p as ConfigureTypeRequest, pn as Metrics, pt as GetHistoryResponse, q as FilterValues, qn as UnlockRequest, qt as GetWorkflowRequest, r as AttachmentDetails, rn as Lock, rr as ValidateRequest, rt as GetDeprecationsResponse, s as BulkGetItem, sn as LockResponse, sr as Workflows, st as GetDocumentTypesResponse, t as ACLEntry, tn as ListSchemaGenerationsRequest, tr as UpdateStatusRequest, tt as GetDeliverableInfoResponse, u as BulkGetResponse, un as Metric, ut as GetExemplarsRequest, v as CreateUploadResponse, vn as RegisterGenerationRequest, vt as GetMetaResponse, w as DeleteStatusRuleRequest, wn as RegisterMetricKindRequest, wt as GetMetricsResponse, x as DeleteMetricKindRequest, xn as RegisterMetaTypeResponse, xt as GetMetricKindsRequest, y as DeleteDocumentRequest, yn as RegisterGenerationResponse, yt as GetMetaTypesRequest, z as EventlogItem, zn as SetWorkflowResponse, zt as GetStatusRulesRequest } from "../service-BHXowTdl.mjs";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
//#region src/repository/service.client.ts
/**
* @generated from protobuf service elephant.repository.Documents
*/
var DocumentsClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Documents.typeName;
		this.methods = Documents.methods;
		this.options = Documents.options;
	}
	/**
	* Get retrieves a document version.
	*
	* @generated from protobuf rpc: Get
	*/
	get(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* BulkGet loads multiple documents in a single request.
	*
	* @generated from protobuf rpc: BulkGet
	*/
	bulkGet(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetHistory lists the document version history.
	*
	* @generated from protobuf rpc: GetHistory
	*/
	getHistory(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Update is used to create new document versions, set statuses, update ACLs.
	*
	* @generated from protobuf rpc: Update
	*/
	update(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* BulkUpdate is used to create new document versions, set statuses, update ACLs.
	*
	* @generated from protobuf rpc: BulkUpdate
	*/
	bulkUpdate(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Validate is used to validate a document without writing it to the
	* repository.
	*
	* @generated from protobuf rpc: Validate
	*/
	validate(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Prune will attempt to remove invalid parts of a document until what remains
	* is valid. If that's not possible it will return the same kind of error
	* information as a Validate call would return, highlighting the remaining
	* issues.
	*
	* @generated from protobuf rpc: Prune
	*/
	prune(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Evict removes stored document versions from the main database. The evicted
	* data will be restored from the archive if requested again by clients. It's
	* not allowed to evict the current version of a document.
	*
	* @generated from protobuf rpc: Evict
	*/
	evict(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Delete deletes a document and all its associated data.
	*
	* @generated from protobuf rpc: Delete
	*/
	delete(input, options) {
		const method = this.methods[8], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListDeleted lists deleted document instances for a UUID.
	*
	* @generated from protobuf rpc: ListDeleted
	*/
	listDeleted(input, options) {
		const method = this.methods[9], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Restore recovers a deleted document.
	*
	* @generated from protobuf rpc: Restore
	*/
	restore(input, options) {
		const method = this.methods[10], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Purge removes a deleted document completely.
	*
	* @generated from protobuf rpc: Purge
	*/
	purge(input, options) {
		const method = this.methods[11], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetMeta returns metadata for a document, including the ACL and current
	* status heads.
	*
	* @generated from protobuf rpc: GetMeta
	*/
	getMeta(input, options) {
		const method = this.methods[12], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Eventlog returns document update events, optionally waiting for new events.
	*
	* @generated from protobuf rpc: Eventlog
	*/
	eventlog(input, options) {
		const method = this.methods[13], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* CompactedEventlog returns document update events. If more than one event
	* has occured for a document in the given window only the latest will be returned.
	*
	* @generated from protobuf rpc: CompactedEventlog
	*/
	compactedEventlog(input, options) {
		const method = this.methods[14], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetStatus returns a single status for a document.
	*
	* @generated from protobuf rpc: GetStatus
	*/
	getStatus(input, options) {
		const method = this.methods[15], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetStatusHistory returns the history of a status for a document.
	*
	* @generated from protobuf rpc: GetStatusHistory
	*/
	getStatusHistory(input, options) {
		const method = this.methods[16], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetNilStatuses returns all the statuses for a document where version is -1.
	*
	* @generated from protobuf rpc: GetNilStatuses
	*/
	getNilStatuses(input, options) {
		const method = this.methods[17], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetStatusOverview returns the current version and a set of statuses for a
	* gven list of documents.
	*
	* @generated from protobuf rpc: GetStatusOverview
	*/
	getStatusOverview(input, options) {
		const method = this.methods[18], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetPermissions returns the permissions you have for the document.
	*
	* @generated from protobuf rpc: GetPermissions
	*/
	getPermissions(input, options) {
		const method = this.methods[19], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Lock attempts to acquire a write lock on a document. Fails with
	* FailedPrecondition when the document is already locked; the
	* failure carries error metadata keys "lock_holder_sub",
	* "lock_app", "lock_comment" and "lock_expires" so callers can
	* distinguish "held by me" (look up the token in own state) from
	* "held by someone else" (surface to the user).
	*
	* @generated from protobuf rpc: Lock
	*/
	lock(input, options) {
		const method = this.methods[20], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ExtendLock extends the expiration of an existing lock.
	*
	* @generated from protobuf rpc: ExtendLock
	*/
	extendLock(input, options) {
		const method = this.methods[21], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Unlock releases a write lock on a document.
	*
	* @generated from protobuf rpc: Unlock
	*/
	unlock(input, options) {
		const method = this.methods[22], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetWithheld returns the next upcoming scheduled publish actions. This is
	* not a complete list, but a list of the next N documents that are considered
	* eligible for publishing.
	*
	* @generated from protobuf rpc: GetWithheld
	*/
	getWithheld(input, options) {
		const method = this.methods[23], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetDeliverableInfo returns available information related to the deliverable.
	*
	* @generated from protobuf rpc: GetDeliverableInfo
	*/
	getDeliverableInfo(input, options) {
		const method = this.methods[24], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* BulkGetDeliverableInfo returns deliverable information for multiple
	* documents in a single request.
	*
	* @generated from protobuf rpc: BulkGetDeliverableInfo
	*/
	bulkGetDeliverableInfo(input, options) {
		const method = this.methods[25], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* CreateUpload is used to start the process of uploading objects that then
	* can be attached to a document.
	*
	* @generated from protobuf rpc: CreateUpload
	*/
	createUpload(input, options) {
		const method = this.methods[26], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetAttachments returns download links for the requested attachments.
	*
	* @generated from protobuf rpc: GetAttachments
	*/
	getAttachments(input, options) {
		const method = this.methods[27], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetMatching returns documents matching the given criteria.
	*
	* @generated from protobuf rpc: GetMatching
	*/
	getMatching(input, options) {
		const method = this.methods[28], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetSocketToken returns a token that can be used to open socket connections.
	*
	* @generated from protobuf rpc: GetSocketToken
	*/
	getSocketToken(input, options) {
		const method = this.methods[29], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service elephant.repository.Schemas
*/
var SchemasClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Schemas.typeName;
		this.methods = Schemas.methods;
		this.options = Schemas.options;
	}
	/**
	* RegisterGeneration registers a new schema generation. Registration is
	* idempotent, so calling RegisterGeneration with the same schema versions
	* will yield the same generation ID.
	*
	* @generated from protobuf rpc: RegisterGeneration
	*/
	registerGeneration(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetActive activates or deactivates a schema generation. Activating a
	* generation always deactivates the currently active schema generation.
	* Deactivation is only relevant in the context of pending schema
	* generations, because deactivating an active schema generation isn't
	* allowed.
	*
	* @generated from protobuf rpc: SetActive
	*/
	setActive(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListGenerations lists the configured schema generations.
	*
	* @generated from protobuf rpc: ListGenerations
	*/
	listGenerations(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetExemplars returns the exemplar documents for a schema generation. Known
	* exemplar version hashes can be provided to avoid re-transferring unchanged
	* documents.
	*
	* @generated from protobuf rpc: GetExemplars
	*/
	getExemplars(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Get retrieves a schema.
	*
	* @generated from protobuf rpc: Get
	*/
	get(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetAllActiveSchemas returns the currently active validation schemas.
	*
	* @generated from protobuf rpc: GetAllActive
	*/
	getAllActive(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListActiveSchemas lists the currently active schemas.
	*
	* @generated from protobuf rpc: ListActive
	*/
	listActive(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* RegisterMetaType registers a type that can be used for meta documents.
	*
	* @generated from protobuf rpc: RegisterMetaType
	*/
	registerMetaType(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* RegisterMetaTypeUse registers a meta type for use with a main type.
	*
	* @generated from protobuf rpc: RegisterMetaTypeUse
	*/
	registerMetaTypeUse(input, options) {
		const method = this.methods[8], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetMetaTypes lists the registered meta types.
	*
	* @generated from protobuf rpc: GetMetaTypes
	*/
	getMetaTypes(input, options) {
		const method = this.methods[9], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetDeprecations lists all deprecations.
	*
	* @generated from protobuf rpc: GetDeprecations
	*/
	getDeprecations(input, options) {
		const method = this.methods[10], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* UpdateDeprecation creates or updates a deprecation.
	*
	* @generated from protobuf rpc: UpdateDeprecation
	*/
	updateDeprecation(input, options) {
		const method = this.methods[11], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetDocumentTypes lists the defined document types.
	*
	* @generated from protobuf rpc: GetDocumentTypes
	*/
	getDocumentTypes(input, options) {
		const method = this.methods[12], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ConfigureType configures a document type.
	*
	* @generated from protobuf rpc: ConfigureType
	*/
	configureType(input, options) {
		const method = this.methods[13], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetTypeConfiguration returns the current configuration for a type.
	*
	* @generated from protobuf rpc: GetTypeConfiguration
	*/
	getTypeConfiguration(input, options) {
		const method = this.methods[14], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service elephant.repository.Workflows
*/
var WorkflowsClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Workflows.typeName;
		this.methods = Workflows.methods;
		this.options = Workflows.options;
	}
	/**
	* UpdateStatus creates or updates a status that can be used for documents.
	*
	* @generated from protobuf rpc: UpdateStatus
	*/
	updateStatus(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetStatuses lists all enabled statuses.
	*
	* @generated from protobuf rpc: GetStatuses
	*/
	getStatuses(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* CreateStatusRule creates or updates a status rule that should be applied
	* when setting statuses.
	*
	* @generated from protobuf rpc: CreateStatusRule
	*/
	createStatusRule(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteStatusRule removes a status rule.
	*
	* @generated from protobuf rpc: DeleteStatusRule
	*/
	deleteStatusRule(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetStatusRules returns all status rules.
	*
	* @generated from protobuf rpc: GetStatusRules
	*/
	getStatusRules(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetWorkflow configures a workflow for a document type.
	*
	* @generated from protobuf rpc: SetWorkflow
	*/
	setWorkflow(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetWorkflow for a document type.
	*
	* @generated from protobuf rpc: GetWorkflow
	*/
	getWorkflow(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteWorkflow removes the workflow configuration for a document type.
	*
	* @generated from protobuf rpc: DeleteWorkflow
	*/
	deleteWorkflow(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service elephant.repository.Metrics
*/
var MetricsClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Metrics.typeName;
		this.methods = Metrics.methods;
		this.options = Metrics.options;
	}
	/**
	* Register a metric kind
	*
	* @generated from protobuf rpc: RegisterKind
	*/
	registerKind(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Delete a metric kind
	*
	* @generated from protobuf rpc: DeleteKind
	*/
	deleteKind(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* List all metric kinds
	*
	* @generated from protobuf rpc: GetKinds
	*/
	getKinds(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Register a data point
	*
	* @generated from protobuf rpc: RegisterMetric
	*/
	registerMetric(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetMetrics returns metrics related to a document.
	*
	* @generated from protobuf rpc: GetMetrics
	*/
	getMetrics(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
//#endregion
export { ACLEntry, AcquireLock, AttachmentDetails, AttachmentRef, BulkGetDeliverableInfoRequest, BulkGetDeliverableInfoResponse, BulkGetItem, BulkGetReference, BulkGetRequest, BulkGetResponse, BulkUpdateRequest, BulkUpdateResponse, ConfigureTypeRequest, ConfigureTypeResponse, CreateStatusRuleRequest, CreateStatusRuleResponse, CreateUploadRequest, CreateUploadResponse, DeleteDocumentRequest, DeleteDocumentResponse, DeleteMetricKindRequest, DeleteMetricKindResponse, DeleteRecord, DeleteStatusRuleRequest, DeleteStatusRuleResponse, DeleteWorkflowRequest, DeleteWorkflowResponse, DeliverableInfo, Deprecation, DocumentFilter, DocumentMatch, DocumentMeta, DocumentMetrics, DocumentStatuses, DocumentVersion, DocumentWorkflow, Documents, DocumentsClient, EntityRef, EventlogItem, EvictRequest, EvictResponse, Exemplar, ExtendLockRequest, ExtractedValue, ExtractedValues, FilterOperator, FilterValues, GetAllActiveSchemasRequest, GetAllActiveSchemasResponse, GetAttachmentsRequest, GetAttachmentsResponse, GetCompactedEventlogRequest, GetCompactedEventlogResponse, GetDeliverableInfoRequest, GetDeliverableInfoResponse, GetDeprecationsRequest, GetDeprecationsResponse, GetDocumentRequest, GetDocumentResponse, GetDocumentTypesRequest, GetDocumentTypesResponse, GetEventlogRequest, GetEventlogResponse, GetExemplarsRequest, GetExemplarsResponse, GetHistoryRequest, GetHistoryResponse, GetMatchingRequest, GetMatchingResponse, GetMetaDoc, GetMetaRequest, GetMetaResponse, GetMetaTypesRequest, GetMetaTypesResponse, GetMetricKindsRequest, GetMetricKindsResponse, GetMetricsRequest, GetMetricsResponse, GetNilStatusesRequest, GetNilStatusesResponse, GetPermissionsRequest, GetPermissionsResponse, GetSchemaRequest, GetSchemaResponse, GetSocketTokenRequest, GetSocketTokenResponse, GetStatusHistoryReponse, GetStatusHistoryRequest, GetStatusOverviewRequest, GetStatusOverviewResponse, GetStatusRequest, GetStatusResponse, GetStatusRulesRequest, GetStatusRulesResponse, GetStatusesRequest, GetStatusesResponse, GetTypeConfigurationRequest, GetTypeConfigurationResponse, GetWithheldRequest, GetWithheldResponse, GetWorkflowRequest, GetWorkflowResponse, ImportDirective, LabelExpression, ListActiveSchemasRequest, ListActiveSchemasResponse, ListDeletedRequest, ListDeletedResponse, ListSchemaGenerationsRequest, ListSchemaGenerationsResponse, Lock, LockExclusivity, LockGrant, LockRequest, LockResponse, MetaDocument, MetaTypeInfo, Metric, MetricAggregation, MetricKind, Metrics, MetricsClient, PruneRequest, PruneResponse, PurgeRequest, PurgeResponse, RegisterGenerationRequest, RegisterGenerationResponse, RegisterMetaTypeRequest, RegisterMetaTypeResponse, RegisterMetaTypeUseRequest, RegisterMetaTypeUseResponse, RegisterMetricKindRequest, RegisterMetricKindResponse, RegisterMetricRequest, RegisterMetricResponse, RestoreRequest, RestoreResponse, ScheduledDocument, Schema, SchemaActivation, SchemaGeneration, SchemaReference, Schemas, SchemasClient, SetActiveSchemasRequest, SetActiveSchemasResponse, SetWorkflowRequest, SetWorkflowResponse, Status, StatusOverviewItem, StatusRule, StatusUpdate, Timespan, TypeConfiguration, TypeTimeExpression, UnlockRequest, UnlockResponse, UpdateDeprecationRequest, UpdateDeprecationResponse, UpdatePermissionsRequest, UpdatePermissionsResponse, UpdateRequest, UpdateResponse, UpdateStatusRequest, UpdateStatusResponse, ValidateRequest, ValidateResponse, ValidationResult, WorkflowStatus, Workflows, WorkflowsClient };
